import React from "react";
import { useAuthorization } from "../../hooks/useAuthorization";
import { Navigate } from "react-router-dom";
import PixelEdumanLoader from "../loading/PixelEdumanLoader";

const ProtectedRoute = ({contents, accessControl}) => {
    const {checkAccessControl} = useAuthorization();
    
    const [isAuthorized, loading] = checkAccessControl(accessControl)
    
    if(loading) {
        return (<PixelEdumanLoader message={"Loading..."} isAbsolute={true} />)
    }

    return isAuthorized ? contents : <Navigate to="/client/home" />
}

export default ProtectedRoute;